
import {createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Fjalla+One&family=Nunito+Sans:ital,opsz,wght@0,6..12,200;0,6..12,300;0,6..12,400;0,6..12,500;0,6..12,600;0,6..12,700;0,6..12,800;0,6..12,900;0,6..12,1000;1,6..12,200;1,6..12,300;1,6..12,400;1,6..12,500;1,6..12,600;1,6..12,700;1,6..12,800;1,6..12,900;1,6..12,1000&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;600;700&family=Overpass:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap');
  *{
    font-family: 'Roboto', sans-serif!important;
    margin-inline-end: 0px;
    padding-inline-end: 0px;
    padding-block-end: 0px;
    margin-block-end: 0px;
    dl,ol,ul{
      margin-bottom:0px!important;
    }
    img{
      user-select:none!important;
    }
  }
  html,body,#root{
    overflow-x:none;
  }
  .brand-name{
    font-family: 'Nunito Sans', sans-serif!important;
  }
  html,body{
    background:${(props) => props.theme.background};
    color:${(props) => props.theme.color};
  }
  
  .changerTheme{
    display:flex;height:100%;justify-content:center,align-items:center;
  }
  
  .authtabList{
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 20px 0px;
  }
  .authtabList button{
    border:0;
    outline:0;
    background-color: ${({ theme }) => theme.mainThemeBackground};
    padding:10px 40px;
    transition:300ms all;
    color:${({ theme }) => theme.opacityColor};
  }
  .authtabList button[aria-selected="true"]{
    background-color: ${({ theme }) => theme.mainThemeColor};
    color: #fff;
    border:2px solid ${({ theme }) => theme.mainThemeBackground};
  }
  .loader{
    width:100%;
    padding:30px 0px;
    display:flex;
    justify-content:center;
    align-items:center;
    
  }
  .productList-parent{
    
    position:relative;
    .filter-buttons{
      width:100%;
      display:flex;
      justify-content:space-between;
      margin:20px 0px;
      .grids{
        display:flex;
        width:100%;
        justify-content:flex-end;
        padding-right:20px;
        .count{
          margin-left:20px;
          border-radius:10px;
          display:flex;
          cursor:pointer;
          justify-content:center;
          align-items:center;
          padding:5px 20px; 
        }
      }
      .filters{
        width:60%;
        display:flex;
        justify-content:space-around;
        cursor:pointer;
        align-items:center;
        div{
          padding:10px 20px;
          background-color:rgba(242,242,242,.4);
          transition:300ms all;
          border-radius:10px;
          .icon{
            margin-left:20px;
          }
          &:hover{
          background-color:rgba(0,0,0,.05);
          }
        }
        div.active{
          background-color:rgba(0,0,0,.2);

        }
        @media only screen and (max-width:1140px){
          flex-wrap:wrap;
          width:100%;
          justify-content:space-between;
          div{
            margin-bottom:20px;
          }
          
        }
      }
      .filters-mobile{
        display:none;
      }
      .filters-mobile{
        width:50%;
        button{
          border:0;
          outline:0;
          background:rgba(242,242,242,.4);
          font-size:13px;
          width:100%;
          padding:10px 0px;
          position:relative;
          border-radius:10px;
          .mobile-filter-list{
            position:absolute;
            width:100%;
            left:0;
            top:100%;
            background:#fff;
            z-index:100;
            box-shadow: 0px 0px 10px #eee;
            div{
              padding:7px 10px;
              &:not(:last-child){
                border-bottom:1px solid #ddd;
              }
            }
          }
        }
      }
      @media only screen and (max-width:1140px){
        flex-wrap:wrap;
        .filters{
          display:none!important;
        }
        .filters-mobile{
          display:flex;
        }
      }
    }
    width:100%;
    
    .product-sorter{
      margin-bottom:-65px;
      z-index:1000!important;
      width:100%;
      display:flex;top:0px;
      z-index:1;
      justify-content:space-between;
    }
  }
  
  @media only screen and (max-width:1140px){
    .productList-parent{
      width:100%;
    }
    
  }
  .unlimited-scroll{
    align-items:center;
    min-height:100vh;
    z-index: 100000;
    max-height:100vh;
    
    overflow:scroll;
    -ms-overflow-style: none;  
    scrollbar-width: none; 
    &::-webkit-scrollbar{
      display: none;
    }
  }
  .unlimited-scroll.variant {
    min-height:unset;
    max-height:unset;
    max-height: 70vh;
    overflow-y: scroll;
    .content-container{
    
    }
  }
  .unlimited-scroll.home{
    max-height: unset!important;
  }
  .content-container{
    display:flex;
    flex-direction:column;
    flex-wrap:wrap;
    z-index: 100000;
    justify-content:space-around;
    
  }
  
  .invoices{
    padding:7px 20px!important;
    cursor:pointer; 
    font-weight:bold;
    font-family: 'Overpass', sans-serif!important;
    transition:600ms all;
    text-decoration:none;
    display:block;
    color:#000;
    border-radius:10px;
    &:hover{
      border-radius:0px;
      color:#000;
      background:rgba(0,0,0,.1);
      font-weight:bold;
    }
  }
  .light-close {
    display: block;
    position: fixed;
    font-size: 22px;
    font-weight: bold;
    color: #fff;
    box-shadow: 0px 0px 19px #000;
    outline: none;
    border: none;
    z-index: 999;
    padding: 10px;
    padding-left: 20px;
    padding-right: 20px;
    right: 438px;
    top: 23px;
    width: 70px;
    background:transparent;
    color:#333;
    font-weight:normal;
    box-shadow:none;
    font-size: 25px;      
    @media only screen and (max-width: 1140px) {
      right: 0;
      top: 0;
      width:50px;
      background:transparent;
      color:#333;
      font-weight:normal;
      box-shadow:none;
      font-size: 25px;      
      
    }
  }
  .cancel{
    margin-left:10px;border:0;outline:0;padding:7px;background:#733;color:#fff;
  }
  .Beklemede{
    background:#fffa65;
  }
  .Onaylandı{
    background:#7bed9f;
  }
  .Muhasebelendi{
    background:#2ed573;
  }
  .İptal{
    background:#e84118;
  }
  .FATURA{
    background:#fbc531;
  }
  .DEKONT{
    background:#9c88ff;
  }
  .BONUS{
    background:#273c75;
  }
  .ÇEK{
    background:#e84118;
  }
  .DEKONT{
    background:#00a8ff;
  }
  .DEVIR{
    background:#ff6b81;
  }
  .EVRAK{
    background:#7bed9f;
  }
  .IRSALIYE{
    background:#2ed573;
  }
  .KREDI-KARTI-IADE{
    background:#ff6348;
  }
  .KREDI-KARTI{
    background:#eccc68;
  }
  .NAKIT{
    background:#ffffff;
  }
  .POS-IADE{
    background:#ffcccc;
  }
  .POS{
    background:#7158e2;
  }
  .SENET{
    background:#67e6dc;
  }
  .SERVIS{
    background:#3ae374;
  }
  .SIPARIS{
    background:#fffa65;
  }
  .TAHAKKUK{
    background:#67e6dc;
  }
  .TAKSIT-VIRMAN{
    background:#67e6dc;
  }
  .VIRMAN{
    background:#67e6dc;
  }
  .mini-product {
    img{
      user-select:none;
    }
    *{
      user-select:none!important;
    }
    transition: 300ms transform;
    .title{
      position:relative;
    }
    .title .btn{
      position:absolute;
      
      width:200px;
      
      background:#f27a1a;
      top:0px;
      color:#fff;
      font-size:14px;
      transition: 500ms all;
      transform:scale(0);
      left:calc(50% - 100px);
    }
    .title .name{
      transition: 500ms all;
    }
    .price{
      font-size:20px;
      text-align:center;
      color:#005bb4;
      transition: 500ms all;
    }
    .title .btn:hover{
      background:#f89648;
    }
    &:hover{
      .title .name,.title .price{
        transform:scale(0);
      }
      .title .btn{
        transform:scale(1);
      }
    }
  }
  .rec-arrow,.rec-arrow,.rec-arrow-left,button.rec{
    // background:#f27a1a!important;
    // &:hover,&:hover:enabled, &:focus:enabled{
    //   background:#f27a4a!important;
    // }
  }
  @media only screen and (max-width: 1140px) {
    button.rec-arrow{
      display:none;
    }
    .home-slider{
      flex-direction:column;
      h1{
        margin:20px 0px;
      }
      button{
        display:none;
      }
      .rec-item-wrapper{
        border-radius:0px!important;
      }
      .rec-item-wrapper img{
        width:100%!important;
        border-radius:0px!important;
        
      }
    }
    
    .home-slider-v{
      
      padding:0px!important;
      width:100%!important;
      img{
        width:100%!important;
        height:100%!important;
        
      }
    }
  }
  .arrow-btn{
    transition: 300ms all;
    transform:scale(0);
    height:0px;
  }
  .home-slider-v{
    h1{
      transition: 300ms all;
      transform:scale(1);
    }
    button{
      transition: 300ms all;
      transform:scale(0)!important;
      height:40px!important;
      
    }
    &:hover{
      h1{
        transform:scale(0);
      }
      button{
        transform:scale(1)!important;
        height:40px!important;
        
      }
    }
  }

  .category-item{
    cursor:pointer;
    
    
    .img{
      height:80px;
      width:80px;
      background-size:100%;
      background-repeat:no-repeat;
      background-position:center;
      margin-bottom:10px;
    }
    padding:10px;
    border-radius:10px;
    &:hover{
    }
    padding:10px;
    
    a{
      font-size:14px;
      text-decoration:none;
      display:flex;
      color:#000;
      user-select:none;
      flex-direction:column;
      flex-direction:column!important;
      justify-content:center;
      align-items:center;
      width:240px;
    }
  }

  ::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1; 
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: #FF9F43; 
}

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555; 
  }
  .dehasoft-img{
    margin-top: 40px!important;
    cursor:pointer;
    height:unset!important;
    width:100px!important;
    max-width:100px!important;
  }
  .go-top-btn{
    bottom:110px!important;
    right:10px!important;
    z-index:100000!important;
    flex-direction:column;
    align-items:center;
    justify-content:center;
    box-shadow:none!important;
    background:transparent!important;
    svg{
      margin-bottom:-5px!important;
    }
    span{
      font-weight:bold!important;
      font-size:9px;
    }
  }
`;
export {GlobalStyle}